// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-nav-ajust[data-v-39979a5f]{color:#fff;cursor:pointer}.icon-nav-ajust[data-v-39979a5f]:hover{color:#b6b6b6}", ""]);
// Exports
module.exports = exports;
